<template>
  <div
    v-if="imageUrl != null"
    class="consultant-image-file"
    :style="{ 'background-image': 'url(' + imageUrl + ')' }"
  ></div>
  <div v-else class="consultant-image-file"></div>
</template>

<script>
export default {
  props: {
    src: { type: [String, Number], default: null }
  },
  data: () => ({
    imageUrl: null
  }),
  watch: {
    src: {
      immediate: true,
      handler(v) {
        if (v) {
          this.downloadImage(v);
        } else {
          this.imageUrl = null;
        }
      }
    }
  },
  methods: {
    async downloadImage(file) {
      const { data } = await this.$axiosStorageApi({
        url: `/file/${file}/download_auth`,
        method: "GET",
        responseType: "blob"
      });

      let reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = () => {
        this.imageUrl = reader.result;
      };
    }
  }
};
</script>
